module.exports = __webpack_public_path__ + "media/audio/ambience/SADA-CHAPTER-1-V3-BACKGROUND-LOOP.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/media/audio/ambience/SADA-CHAPTER-1-V3-BACKGROUND-LOOP.mp3
// module id = 26
// module chunks = 0